import { parseInboundPayload } from '../../inbound';
import { numberParser, stringParser } from '../../inboundParsers';
import { trimBraces } from '../../inboundUtils';
export function playerStyleStringParser(str) {
    const styleParts = trimBraces(str).split(',');
    return parseInboundPayload(styleParts, playerStylePartDefinitions);
}
const playerStylePartDefinitions = [
    { name: 'numHands', parser: numberParser },
    { name: 'vpipScore', parser: numberParser },
    { name: 'vpipLabel', parser: stringParser },
    { name: 'afScore', parser: numberParser },
    { name: 'afLabel', parser: stringParser },
    { name: 'styleNickname', parser: stringParser }
];
